import { appDomain } from "./domain/AppDomain";

export class GlobalErrorHandler {
    constructor() {
        const self = this;
        window.addEventListener("unhandledrejection", function (e: any) {
            e.stopPropagation();
            self.handleError(e || e.detail || e.detail.reason);
            return false;
        });
    }
    handleError(error: any) {
        if (error.rejection) {
            error = error.rejection;
        }
        appDomain.IHandleExceptions.handleException(error);
    }
  }

  new GlobalErrorHandler();